import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static get targets() {
    return [
      "domesticPanel", "internationalPanel", "domesticSelect", "internationalSelect",
      "hiddenInput", "customPackagingSelector", "collectionBaseSelector", "collectionSelectors"
    ];
  }

  connect() {
    // Both syncs run together, gated on the custom-packaging question rendering. On a page with
    // no collection_base select the second is a harmless no-op - the panel is visible by default.
    if (this.hasCustomPackagingSelectorTarget) {
      this.toggleCustomPackaging();
      this.toggleCollectionBase();
    }
  }

  toggleType(event) {
    if (event.target.value === "domestic") {
      this.showDomestic();
      this.hiddenInputTarget.value = this.domesticSelectTarget.value;
    } else {
      this.showInternational();
      this.hiddenInputTarget.value = this.internationalSelectTarget.value;
    }
  }

  syncHidden(event) {
    this.hiddenInputTarget.value = event.target.value;
  }

  showDomestic() {
    this.domesticPanelTarget.style.display = "block";
    this.internationalPanelTarget.style.display = "none";
  }

  showInternational() {
    this.internationalPanelTarget.style.display = "block";
    this.domesticPanelTarget.style.display = "none";
  }

  toggleCustomPackaging() {
    const wantEligible = this.customPackagingSelectorTarget.value === "Yes";
    let firstMatch = null;

    [this.domesticSelectTarget, this.internationalSelectTarget].forEach(select => {
      Array.from(select.options).forEach(option => {
        const isEligible = option.dataset.custompkg === "true";
        if (isEligible === wantEligible) {
          option.style.display = "block";
          firstMatch = firstMatch || option;
        } else {
          option.style.display = "none";
        }
      });
    });

    if (firstMatch) { firstMatch.selected = true; }
  }

  toggleCollectionBase() {
    const value = this.hasCollectionBaseSelectorTarget ? this.collectionBaseSelectorTarget.value : undefined;
    const hide = value === "platform";
    this.collectionSelectorsTargets.forEach(el => { el.style.display = hide ? "none" : "block"; });
  }
}
